(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Sticky header shrink */
  var hw = document.getElementById('HeaderWrapper');
  if (hw) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 40) {
        hw.classList.add('scrolled');
      } else {
        hw.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  /* Mobile menu */
  var menuToggle = document.getElementById('MobileMenuToggle');
  var mobileMenu = document.getElementById('MobileMenu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }

  window.closeMobileMenu = function () {
    var mm = document.getElementById('MobileMenu');
    if (mm) {
      mm.classList.remove('open');
      document.body.style.overflow = '';
    }
  };

  /* Dropdowns: hover is CSS-only; this adds tap/keyboard support. A '#'
     parent never navigates — it just toggles its panel. */
  function hnavCloseAll() {
    document.querySelectorAll('.hnav-drop.open').forEach(function (d) {
      d.classList.remove('open');
      var t = d.querySelector('.hnav-trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  document.querySelectorAll('.hnav-drop > .hnav-trigger').forEach(function (t) {
    t.addEventListener('click', function (e) {
      if (t.getAttribute('href') === '#') {
        e.preventDefault();
        var d = t.parentElement;
        var was = d.classList.contains('open');
        hnavCloseAll();
        if (!was) { d.classList.add('open'); t.setAttribute('aria-expanded', 'true'); }
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.hnav-drop')) hnavCloseAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { hnavCloseAll(); window.closeMobileMenu && window.closeMobileMenu(); }
  });

  } catch(e) { console.error(e); }
})();
})();
